var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-2 mr-2",attrs:{"small":"","color":"secondary"}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.mdiFilter))])],1)]}}])},[_c('v-card',[_c('v-card-text',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }